import { useQuery } from '@apollo/client';
import { GET_DASHBOARD_STATS } from '@gql/alerts';

export const useGetDashboardStats = (date?: Date) => {
    const { data, loading, error, refetch } = useQuery(GET_DASHBOARD_STATS, {
        variables: { ...(date && { date }) },
        notifyOnNetworkStatusChange: true,
    });

    return {
        stats: data?.getDashboardStats ?? null,
        loading,
        error,
        refetch,
    };
};
